import { towne as towneConfig } from "@max/thirdparty/companies/towne";
import { GtbAffiliationMap } from "@max/common/dist/thirdparty/gtb";

import { UserMenuOptions } from "../gtb/Components/UserMenuOptions";
import { GtbCustomApp } from "../gtb/types";
import { gtb } from "../gtb";

export const towne: GtbCustomApp = {
  ...towneConfig,
  routes: gtb.routes,
  UserMenuOptions,
  userRoles: JSON.parse(
    JSON.stringify(GtbAffiliationMap).replaceAll("GTB", "Towne"),
  ),
};
